<app-button
  [label]="userName"
  icon="person_outline"
  layout="button-border button-size-auto icon-user-profile"
  variant="transparent"
  (buttonClick)="openEditUserPerfil()">
</app-button>
